import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;

  .color-body {
    overflow-y: auto;
    color: ${(props) => props.theme.$gray900};
  }

  .color-swatch {
    height: 40px;
    border: 0;
    border-radius: 6px;
    padding: 0;
    transition: box-shadow 0.15s ease;
  }

  .color-swatch:hover,
  .color-swatch:focus {
    box-shadow: 0 0 0 2px ${(props) => props.theme.$white},
      0 0 0 4px ${(props) => props.theme.$gray400};
    outline: 0;
  }

  .color-swatch .material-icons {
    font-size: 20px;
  }

  .color-footer {
    flex-shrink: 0;
    border-top: 1px solid ${(props) => props.theme.$gray300};
  }
`;
